import { useEffect, useState } from 'react';

const useScripts = (urls, onLoad) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let scriptsLoaded = 0;

    const handleScriptLoad = () => {
      scriptsLoaded += 1;
      if (scriptsLoaded === urls.length) {
        setLoaded(true);
        if (onLoad) onLoad();
      }
    };

    urls.forEach((url) => {
      if (!document.querySelector(`script[src="${url}"]`)) {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.referrerPolicy = 'no-referrer';

        script.onload = handleScriptLoad;

        script.onerror = () => {
          console.error(`Failed to load script: ${url}`);
        };

        document.head.appendChild(script);
      } else {
        // If script already exists, consider it as loaded
        scriptsLoaded += 1;
        if (scriptsLoaded === urls.length) {
          setLoaded(true);
          if (onLoad) onLoad();
        }
      }
    });

    return () => {
      urls.forEach((url) => {
        const script = document.querySelector(`script[src="${url}"]`);
        if (script) {
          document.head.removeChild(script);
        }
      });
    };
  }, [urls, onLoad]);

  return loaded;
};

export default useScripts;
